<template>
<div style="width: 100%;background-color: white;min-height: 600px;position: relative">
  <process-design></process-design>
</div>
</template>

<script>
import ProcessDesign from './views/admin/layout/ProcessDesign'
export default {
  name: "myProcessDesign",
  components:{
    ProcessDesign
  },
  data(){
    return {
      schedule_id:''
    }
    
  },
  provide() { 
    // 使用函数的形式，可以访问到 `this` 
    
    return { schedule_id: () =>this.schedule_id }
   },
  watch:{
    $route:{
      handler(v){
        console.log(v)
        this.schedule_id = v.query.schedule_id;
      },
      deep:true,
      immediate:true
    }
  }
}
</script>

<style scoped>

</style>